import remote from '../remote'

const state = {
  drivers: []
}

const getters = {
  DRIVERS: state => {
    return state.drivers
  },
  DRIVERS_BY_ID: (state, getters) => (id) => {
    return state.drivers.find(driver => driver.id === id)
  }
}

const mutations = {
  SET_DRIVERS: (state, payload) => {
    state.drivers = payload
  }
}

const actions = {
  GET_DRIVERS: async (context, payload) => {
    const { data } = await remote().get('/api/users/drivers')
    context.commit('SET_DRIVERS', data)
  }
}

export default {
  state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/modules/drivers.js